module.exports = __webpack_public_path__ + "static/img/dialog-prize-miss.00c7b630.png";